<template>
  <div>
    <div class="air__utils__heading">
      <h3>Términos y condiciones</h3>
    </div>
    <div class="row">
      <div class="col-lg-12 text-right">
        <a-button type="primary" class="float-right" @click="showDrawerNew('')">Crear</a-button> <br> <br>
        <!-- <button @click="getTerms">Get Terms</button> -->
      </div>
    </div>

    <section class="terms">
      <div class="terms__item-box" v-for="item in itemsTerms">
        <p class="terms__item-box__item terms__item-box__item-label">{{ item.title }}</p>
        <a-button type="primary" class="float-right button" @click="showDrawer(item)">Editar</a-button> <br> <br>
      </div>
    </section>

    <a-drawer placement="right" :closable="false" @close="onClose" :visible="itemDetailShow"
      width=740>

      <!-- <ItemDetail :content.sync="content" :isUpdated="isUpdated" closable="true" v-on:closeDetail="onClose($event)" v-on:updateProfiles="update()"/> -->
      <ItemTermsDetail :content.sync="content" :isNew="this.isNew" :id="idItemSelected" :currentItem="currentItem" v-on:closeDetail="onClose($event)" :terms="itemsTerms" @updateTerms="handleUpdateTerms"></ItemTermsDetail>
    </a-drawer>
  </div>
</template>

<script>
import ItemDetail from './widgets/itemDetail';
import ItemTermsDetail from './widgets/itemTermsDetail.vue';
import axios from 'axios';
import { countryConfig } from '../../country-config/country-config';

export default {
  components: {
    ItemDetail,
    ItemTermsDetail
  },
  data() {
    return {
      itemDetailShow: false,
      content: "",
      itemsTerms: [],
      idItemSelected: null,
      currentItem: {},
      isNew: false
    }
  },
  created() {
    // this.fetch()
    this.getTerms();
  },
  methods: {
    showDrawer(content) {
      this.idItemSelected = content.id;
      this.currentItem = content;
      this.itemDetailShow = true;
      this.isNew = false;
    },
    showDrawerNew(content, isNew) {
      this.currentItem = {
        id: undefined,
        title: "",
        slug: "",
        objectID: ""
      };
      this.content = content
      this.itemDetailShow = true
      this.isNew = true;
    },
    onClose($event) {
      this.itemDetailShow = false;
    },
    onSelect(record, selected, selectedRows, nativeEvent) {
      //console.log(selected[0])
      this.showDrawer(selected[0])
    },
    update() {
      this.$emit('update', true)
    },
    getTerms() {
      this.terms = axios.get(
        countryConfig.properties,
        {
          headers: {
            'country': "COL"
          },
          params: {
            objectID: 'TERMS_CMS_COL_LIST'
          }
        }
      )
      .then(({ data }) => {
        //console.log('Terms', data.terms)
        console.log('Terms', data.termsList)
        return this.itemsTerms = data.termsList;
      }).catch(err => {
        //console.log(err);
      })
    },
    decodeEntities(encodedString) {
      var translate_re = /&(nbsp|amp|quot|lt|gt);/g;
      var translate = {
        "nbsp": " ",
        "amp": "&",
        "quot": "\"",
        "lt": "<",
        "gt": ">"
      };
      return encodedString.replace(translate_re, function (match, entity) {
        return translate[entity];
      }).replace(/&#(\d+);/gi, function (match, numStr) {
        var num = parseInt(numStr, 10);
        return String.fromCharCode(num);
      });
    },
    handleUpdateTerms(terms){
      if(terms){
        this.itemsTerms = terms;
      }else{
        this.getTerms();
      }
    }
  },
  computed: {
    /* titleDetail: function () {
      return this.isUpdated ? ('Configuración de Perfil: ' + this.content.namePerfil) : 'Nuevo'
    },
    isUpdated: function () {
      return this.content.hasOwnProperty('namePerfil')
    }, */
  }
}
</script>

<style>
.terms__item-box {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: flex-start;
  justify-content: flex-start;
  align-items: center;
}

.terms__item-box{
  border-bottom: .1rem solid #ebebeb;
}
.terms__item-box__item {
  padding: 1rem;
}
.terms__item-box__item-label{
  width: 80%;
}
.button{
  margin: 0 .5rem;;
}
</style>